import MobileDetect from 'mobile-detect';

import DemoDataService from './demo.data.service.js';
import GDriveDataService from './gdrive.data.service.js';

function PiggyBankService(options, app) {
    if (!(this instanceof PiggyBankService)) {
        return new PiggyBankService(options, app);
    }

    const pbs = this;
    const demoData = new DemoDataService();
    let googleData, dropboxData, isMobile = false;

    app.$root.$on("google-logged", GoogleUser => {
        googleData = new GDriveDataService(options.appName, GoogleUser, () => {
            app.$root.$emit("logged");
            app.$forceUpdate();
        });
    });

    app.$root.$on("google-logged-out", () => {
        googleData = undefined;
        app.$root.$emit("logged-out");
        app.$root.$forceUpdate();
    });


    app.$root.$on("dropbox-logged", DropboxUser => {
        dropboxData = undefined;
        app.$root.$emit("logged");
        app.$root.$forceUpdate();
    });

    app.$root.$on("dropbox-logged-out", () => {
        dropboxData = undefined;
        app.$root.$emit("logged-out");
        app.$root.$forceUpdate();
    });


    Object.defineProperties(this, {
        data: {
            get() {
                return googleData || dropboxData || demoData;
            }
        },
        mobile: {
            get() {
                return isMobile;
            }
        }
    });

    const md = new MobileDetect(window.navigator.userAgent);
    if (md.is('iPhone')) {
        document.body.classList.add('fix-iphone');
    }

    window.addEventListener('resize', onPiggyBankSize);

    function onPiggyBankSize() {
        const mobile = isMobile;
        let { innerHeight, innerWidth } = window;
        
        isMobile = innerWidth < 1200 || !!md.mobile();
        
        if (mobile !== isMobile) {
            app.$root.$emit("mobile", isMobile);
        }
    }

    window.addEventListener('click', function(event) {
        app.$root.$emit("app-click", event);
    });

    onPiggyBankSize();
}

function install(Vue, options) {
    let pg;

    Object.defineProperties(Vue.prototype, {
        $piggyBank: {
            get() {
                return pg;
            }
        }
    });

    Vue.mixin({
        beforeCreate() {
            pg = pg || new PiggyBankService(options, this);
        }
    });
}

export default install;